import type {CSSProperties} from 'react'
import type {Asset} from '@github-ui/swp-core/schemas/contentful/contentTypes/asset'

export function getAssetImageStyle(asset?: Asset): CSSProperties | undefined {
  const imageDimensions = asset?.fields.file.details?.image

  if (!imageDimensions?.width || !imageDimensions?.height) return undefined

  return {'--brand-image-aspectRatio': `${imageDimensions.width} / ${imageDimensions.height}`}
}
